import React from 'react'
import Header from '../components/Header'
import "./Styles.css"
import Footer from '../Sections/Footer'


const Privacy = () => {
    return (
        <div className='pages-wrapper-main'>
            <Header />
            <div className='heading2'>Privacy Policy</div>

            <div className='pages'>
                <h5>1. Introduction:</h5>

                Purpose and Scope:

                Thank you for visiting Intern Crafters ("Company," "we," "us," or "our") website. This Privacy Policy outlines how we collect, use, disclose, and protect information gathered from visitors and users ("you" or "your") of our website and services. By accessing or using our website, you acknowledge that you have read, understood, and agree to the terms of this Privacy Policy.

                Commitment to Protecting Users' Privacy:

                We are committed to protecting your privacy and ensuring the security of your personal information. We understand the importance of maintaining the confidentiality of the information you provide to us and use industry-standard security measures to safeguard your data.

                <br></br>
                <br></br>
                <h5>2. Information Collection:</h5>
                Types of Information Collected:

                We may collect two types of information: personal information and non-personal information. Personal information may include your name, email address, contact information, and any other information you voluntarily provide to us. Non-personal information may include your IP address, browser type, device information, and website usage data.

                How Information is Collected:

                We collect information through various methods, including when you voluntarily submit information through our website, register for an account, subscribe to our newsletter, participate in surveys or promotions, or interact with our website using cookies and similar tracking technologies.

                <br></br>
                <br></br>
                <h5>3. Use of Information:</h5>

                How Collected Information is Used:

                We may use the information we collect to provide and improve our services, personalize your experience, communicate with you, administer contests or promotions, analyze trends, and gather demographic information for internal purposes.

                Transparency about Third-Party Service Providers:

                We may engage third-party service providers to assist us in operating our website and providing our services. These third parties may have access to your personal information only to perform specific tasks on our behalf and are obligated not to disclose or use it for any other purpose.

                <br></br>
                <br></br>
                <h5>4. Information Sharing:</h5>

                Circumstances of Information Sharing:

                We may share your information with third parties under certain circumstances, including with our trusted partners, affiliates, or service providers to facilitate our services, comply with legal obligations, enforce our policies, or protect our rights, property, or safety.

                Options for Opting Out:

                You have the option to opt out of certain data sharing practices. However, please note that opting out may impact your ability to access certain features or services offered through our website.

                <br></br>
                <br></br>
                <h5> 5. Data Security:</h5>

                Measures Taken to Safeguard User Information:

                We implement various security measures to protect the confidentiality and integrity of your information, including encryption, secure servers, and regular security audits. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.

                Commitment to Data Protection and Compliance:

                We are committed to complying with relevant data protection laws and regulations and continuously strive to update and improve our security practices to safeguard your information.

                <br></br>
                <br></br>

                <h5>6. User Rights:</h5>

                Rights Regarding Personal Information:

                You have certain rights regarding your personal information, including the right to access, correct, update, or delete your information. You may also have the right to restrict or object to the processing of your information and the right to data portability.

                Instructions for Exercising Rights:

                To exercise your rights or make inquiries about your personal information, please contact us using the contact information provided in this Privacy Policy. We will respond to your request in a timely manner and in accordance with applicable laws.

                <br></br>
                <br></br>

                <h5>7. Policy Updates:</h5>

                Right to Update the Privacy Policy:

                We reserve the right to update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or industry standards. We encourage you to review this Privacy Policy periodically for any updates or changes.

                Notification of Changes:

                We will notify you of any significant changes to this Privacy Policy by posting a prominent notice on our website or sending you a direct notification. The updated Privacy Policy will be effective immediately upon posting on our website.

                <br></br>
                <br></br>

                <h5>8. Contact Information:</h5>

                Inquiries or Concerns:

                If you have any questions, concerns, or complaints about this Privacy Policy or our privacy practices, please contact us at interncrafters@gmail.com.

                Feedback and Communication:

                We value your feedback and encourage you to reach out with any questions, comments, or suggestions regarding our Privacy Policy or any other aspect of our website or services.
            </div>
            <Footer />
        </div>
    )
}

export default Privacy
